import * as React from 'react';

import { Mouse } from '@longline/aqua-ui/controls/Mouse';

import { IRect } from '../../types/IRect';
import { RectEditorSurface } from './RectEditorSurface';
import { RectEditorPoints } from './RectEditorPoints';
import { Guide } from '../../ui/Guide';

interface IProps {
  /** Rect */
  rect: IRect;
  /** Horizontal grid resolution */
  resolution: number;
  /** Fired when rects's points change. */
  onChange: (rect: IRect) => void;
}

const RectEditor = (props: IProps) => {
  const handleChange = (newRect: IRect) => {
    props.onChange(newRect);
  }

  return (
    <>
      {/* Unnecessary. */}
      {/* <Guide x={16} y={64} title="Editing a simulation area">
        <ul>
          <li>Click <Mouse size={14} left/> and drag a corner point to resize the area.</li>
          <li>Click <Mouse size={14} left/> and drag the area's surface to move the area.</li>
        </ul>
      </Guide> */}
      <RectEditorSurface rect={props.rect} resolution={props.resolution} onChange={handleChange} />
      <RectEditorPoints  rect={props.rect} onChange={handleChange}/>
    </>
  );
}

export { RectEditor }
